import { Component, TemplateFunction } from '@ribajs/core'

export class SbSeoContentComponent extends Component {
  public static tagName = 'sb-seo-content'

  public scope = {}

  static get observedAttributes(): string[] {
    return []
  }

  protected requiredAttributes(): string[] {
    return []
  }

  constructor() {
    super()
  }

  protected connectedCallback() {
    super.connectedCallback()
    this.init(SbSeoContentComponent.observedAttributes)
    this.addEventListeners()
  }

  protected disconnectedCallback() {
    super.disconnectedCallback()
    this.removeEventListeners()
  }

  /**
   * Called after this custom element is bound and ready
   */
  async afterBind() {
    await super.afterBind()
    this.classList.add(`${SbSeoContentComponent.tagName}-ready`)
  }

  protected addEventListeners() {
    // No event listeners
  }

  protected removeEventListeners() {
    // No event listeners
  }

  protected template(): ReturnType<TemplateFunction> {
    return null
  }
}
